import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-753748d7")

_pushScopeId("data-v-753748d7")
const _hoisted_1 = {
  key: 0,
  class: "faq-delimiter"
}
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "faqTitle" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "pt6"
}
const _hoisted_7 = { class: "text-r" }
const _hoisted_8 = { class: "text-length-title" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" /150 ")
const _hoisted_10 = {
  key: 2,
  class: "pt6"
}
const _hoisted_11 = { class: "faqQuestion" }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = {
  key: 0,
  class: "faqTitle"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_15 = {
  key: 3,
  class: "pt6"
}
const _hoisted_16 = { class: "text-r" }
const _hoisted_17 = { class: "text-length-title" }
const _hoisted_18 = { class: "text-length-title" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" /500 ")
const _hoisted_20 = {
  key: 4,
  class: "faqAnswer"
}
const _hoisted_21 = {
  key: 1,
  style: {"width":"100%","display":"flex","flex-direction":"column","align-items":"center","height":"calc(100% - 84px)","transform":"translate(0%, 0%)","justify-content":"center"}
}
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-info info-faq fs-40" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { style: {"color":"#A1A1A1","font-size":"14px","padding-top":"15px","text-align":"center"} }, "Click Edit to add more questions and answers", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.faqs.length)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          style: {"width":"100%"},
          class: { 'px-lg-3': _ctx.editMode }
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.faqs, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: ["faq-item", _ctx.editMode ? 'editMode' : 'viewMode'],
              key: index
            }, [
              (!_ctx.editMode && index != 0)
                ? (_openBlock(), _createBlock("div", _hoisted_1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_2, [
                _createVNode("div", null, [
                  _createVNode("span", _hoisted_3, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('faq.question.title')) + " " + _toDisplayString(index + 1), 1),
                    _hoisted_4
                  ]),
                  (_ctx.editMode && item.id)
                    ? (_openBlock(), _createBlock("i", {
                        key: 0,
                        class: "icon-f icon-earth-shape fs-20 pl10",
                        onClick: ($event: any) => (_ctx.addTranslations(item.id))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.deleteFAQItem(index)),
                      class: "icon"
                    }, [
                      _hoisted_5
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _withDirectives(_createVNode("input", {
                      required: "",
                      type: "text",
                      maxlength: "150",
                      "data-tab": _ctx.productDetailSections.FAQ,
                      "onUpdate:modelValue": ($event: any) => (item.question = $event),
                      class: "bookit-input product-input form-control h48"
                    }, null, 8, ["data-tab", "onUpdate:modelValue"]), [
                      [_vModelText, item.question]
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("span", _hoisted_8, [
                        _createVNode("span", {
                          class: { 'length-limit': item.question.length > 149 }
                        }, _toDisplayString(item.question.length), 3),
                        _hoisted_9
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("span", _hoisted_11, _toDisplayString(item.question), 1)
                  ])),
              _createVNode("div", _hoisted_12, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('faq.answer.title')), 1),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.editMode)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _withDirectives(_createVNode("textarea", {
                      required: "",
                      name: "textArea",
                      id: "arrivalInstructions",
                      class: "bookit-textarea product-textarea resize-off long-description form-control",
                      maxlength: "500",
                      "onUpdate:modelValue": ($event: any) => (item.answer = $event),
                      "data-tab": _ctx.productDetailSections.FAQ
                    }, null, 8, ["onUpdate:modelValue", "data-tab"]), [
                      [_vModelText, item.answer]
                    ]),
                    _createVNode("div", _hoisted_16, [
                      _createVNode("span", _hoisted_17, [
                        _createVNode("span", _hoisted_18, [
                          _createVNode("span", {
                            class: { 'length-limit': item.answer.length > 499 }
                          }, _toDisplayString(item.answer.length), 3),
                          _hoisted_19
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(item.answer), 1))
            ], 2))
          }), 128))
        ], 2))
      : (!_ctx.editMode)
        ? (_openBlock(), _createBlock("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23
          ]))
        : _createCommentVNode("", true),
    (_ctx.items.length > 3 && !_ctx.editMode && !_ctx.showAll)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAll = true)),
          style: {"justify-content":"center"},
          class: "show-all-clear-filter align-items-lg-center m-auto pt-3"
        }, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
})